<script>
import { ShadowRoot } from './../../libraries/ShadowRoot.js';
import { StoreForm } from './../../register/steps/StoreForm.js';
import CurrencyFormatter from './../../components/Elements/CurrencyFormatter.svelte';
import { PlansStore } from './../Plans.store.js';
import { parseHtmlString } from "../../libraries/parseHtmlString";
import { random_string } from '../../libraries/random_string';
import { CartParserAddons } from '../../register/steps/StoreCart';
import { SubscriptionsStore } from './../SubscriptionsStore';
import { turpial } from 'tripod-styles/src/libraries/turpial.js';
import { parse_membership_name } from 'tripod-styles/src/models/SubscriptionInterface';


export let tripod_plans;
export let interval;
export let affiliate = {};
export let user = {};
export let membership_selected;
export let onSelectPlan = function(){}; // for internal modules
let metadata = tripod_plans;
let showProducts = tripod_plans?.showProducts ?? true;


let lang = metadata.lang;

$: {
    if($PlansStore){
        membership_selected = $PlansStore.membership_selected;
    }
}




// this will work only in register widget.
let subscriptions = [];
if(($StoreForm?.dataForm?.subscriptions)){
    subscriptions = $StoreForm?.dataForm?.subscriptions ?? [];    
}

let email_marketing_purchased = false;

function EmailMarketingSliderUpdate({
    selected_addon,
    value,
    selected,
    list,
}){
    
    if(selected === value){
        email_marketing_purchased = true;
    }else{
        email_marketing_purchased = false;
    }
}

function SelectPlanInit(){
    let button = this;
    let plan_id = button.dataset.planId;
    let plan = parsedPlans.find(( plan )=>{
        if(plan.__id__ === plan_id){
            return plan;
        }
    })
    plan.membership_type = parse_membership_name(plan.membership_type);
    selectPlan(button, plan);
}

function selectPlan(target, plan){
    let email_marketing = $ShadowRoot.querySelector(`.container-plan-${plan.__id__} .email-marketing-slider-module .input-range-selector`);
    plan.addons = {};

    

    if(email_marketing !== ""){
        try {
            plan.addons.email_marketing = JSON.parse(atob(email_marketing.value))
        } catch (error) {
            console.log(error);
        }
    }
    
    plan.addons = new CartParserAddons( plan.addons );
    let button = target;
    // will be executed outside any module
    tripod_plans.onSelect(plan, interval, plan.interval, button);

    // will be executed in internal modules
    
    onSelectPlan({
        plan: plan, interval: interval, button: button
    });
}

let parsedPlans = [];

let current_plan = null;

$: {
    if($PlansStore || $SubscriptionsStore.subscriptions){

        let subscriptions = $SubscriptionsStore.subscriptions;

        parsedPlans = $PlansStore.plans_views.filter(( plan )=>{
            let referralDiscounts = affiliate?.referralDiscounts ?? null;
            let discountPlans = referralDiscounts?.plans ?? null;
            let interval_price;
            let percentOff = 0;
            plan.has_discount = ""; // from switching to anual plan...
            plan.has_special_discount = false; // from referral from coupon
            plan.is_selected = false;
            plan.upgrades = [];
            plan.downgrades = [];
            subscriptions.map(( subscription )=>{       
                let metadata = subscription.metadata;
                let items = subscription.items.data;
                items.map(( item )=>{
                    let subscription_plan = item.plan;
                    let id = item.id_plan;
                    if(plan.__id__ === id && metadata.membership_type === membership_selected){
                        let addons = metadata?.addons ?? null;
                        if(addons !== null){
                            addons = JSON.parse(addons);
                            let addonsObject = {};
                            addons.map((addon)=>{
                                addonsObject[addon.addon_type] = addon;
                            })
                            plan.active_addons = addonsObject;
                        }


                        plan.is_selected = true;
                        plan.interval = subscription_plan.interval;
                        plan.status = subscription.status;
                        current_plan = plan;
                        plan.subscription = subscription;

                    }
                    if(metadata.membership_type === membership_selected){
                        plan.subscription = subscription;
                    }
                })

                

            })

            if(interval !== "month"){
                if(typeof plan[`interval_${interval}_price`] === "undefined" || plan[`interval_${interval}_price`] === ""){
                    interval_price = plan.price_plan;
                    percentOff = 0;
                }else{
                    interval_price = plan[`interval_${interval}_price`];
                    percentOff = (plan.price_plan*100)/plan[`interval_${interval}_price`]-100;
                    percentOff = isNaN(percentOff) === false ? percentOff : 0;
                    percentOff = Number.parseInt(percentOff);
                    plan.has_discount = "has_discount";
                }
            }else{
                interval_price = plan.price_plan;
                percentOff = 0;
            }

            

            plan.interval_current_price = interval_price;

            function onDicountsPlan(discountPlan, is_global = false){
                if(discountPlan.plan === plan.__id__ || is_global === true){
                    let discountPercent = discountPlan?.discountPercent ?? null;
                    
                    if(discountPercent <= 0 || discountPercent === null){
                        return false;
                    }

                    

                    /**
                     * if already has a discount due to a global discount.
                    */
                    if(plan.has_special_discount === true){
                        return false;
                    }
                    

                    plan.interval_current_price = interval_price;
                    interval_price = interval_price - ((discountPlan.discountPercent/100)*interval_price);

                    

                    plan.interval_discount = plan.interval_current_price - interval_price;
                    plan.hasReferralDiscounts = discountPlan.discountPercent;                    
                    plan.has_special_discount = true;
                    
                    

                    if(plan.hasReferralDiscounts <= 0 || plan.hasReferralDiscounts <= false){
                        plan.hasReferralDiscounts = false;
                        plan.has_special_discount = false;
                    }
                }
            }
            plan.interval_selected = interval;

            

            // in case of discounts by referrals

            if(discountPlans  !== null){
                Object.values(discountPlans).map(( dp )=>{
                    onDicountsPlan(dp);
                })
            }else{
                // in case of discounts by tag
                if((plan.discountsPlan ?? null) !== null){
                    onDicountsPlan(plan.discountsPlan);
                }
            }


            if(referralDiscounts !== null){
                try {
                    let global_discount = referralDiscounts?.global_discount ?? null;
                    if(Object.values(global_discount).length !== 0 && global_discount !== null){
                        onDicountsPlan(global_discount, true);
                    }
                } catch (error) {
                    
                }
            }


            plan.hasReferralDiscounts = plan?.hasReferralDiscounts ?? false;
            

            interval_price = Number.parseFloat(Number.parseFloat(interval_price).toFixed(2))

            plan.interval_price = interval_price;
            plan.percentOff = percentOff ?? 0;

            let currency = plan.currency ?? null !== null ? plan.currency : tripod_plans.currency;
            let is_recommended = ((plan.is_recommended ?? "Default") === "Recomendado") ? "recommended" : plan.is_recommended||"";
            let yearly = typeof plan.interval_year_price === "undefined" ? null : plan.interval_year_price;
            plan.currency = currency;
            plan.is_recommended = is_recommended;
            plan.yearly = is_recommended;
            plan.is_available = plan.is_available || "public";

            plan.active = false;


            let same_interval = (plan?.interval ?? null) === interval;
            if(plan.is_selected){
                plan.active = true;
                email_marketing_purchased = true;
                if(!same_interval){
                    plan.active = false;
                }
            }
            

            if(plan.status === "canceled"){
                plan.active = false;
            }
            

            let currentPlan = tripod_plans?.currentPlan ?? null;
            let currentSubscription = tripod_plans?.currentSubscription ?? null;
            
            try {
                if(currentPlan.__id__ !== plan.__id__ && plan.is_selected === false){
                    plan.active = false;
                }else{
                    plan.active = true;
                    email_marketing_purchased = true;
                }
            } catch (error) {
                plan.active = false;
            }

            if(((plan?.interval ?? null) === interval) === false){
                plan.active = false;
            }
            
            /**
             * verify current plan from subscription
            */
           if((currentSubscription?.plan?.id_plan ?? null) !== null){
                if(currentSubscription.plan.id_plan === (plan?.id_plan ?? plan?.__id__) ?? null){
                    plan.active = true;
                }
           }
            
           /**
            * if the interval to year changes set as not active plan.
           */
            if(currentSubscription !== null){
                if(interval !== currentSubscription.prices[0].interval){
                    plan.active = false;
                }
            }

            let forceCurrentPlan = tripod_plans?.forceCurrentPlan ?? false;
            if(forceCurrentPlan !== false){
                if(forceCurrentPlan === plan.__id__){
                    plan.active = true;
                }
            }

            let tag = user?.userFromCampaign ?? user.user_from_campaign ?? "";
            if(plan.is_available === "public" || tag === (plan?.tag || null)){
                return plan;
            }
        })

    }
}



function template_item(string, plan){
    string = parseHtmlString(string);
    string = turpial.template(string, {
        video_storage: `<span class="has-text-primary has-text-weight-bold">${plan.video_storage}GB</span>`
    })

    return string;
}

/**
 * show details about plans
 */
function show_more_details(event){
    let button = event.target;
    let container = button.parentNode;

    let bullets = [...container.querySelectorAll(".hidden-bullets")];

    bullets.map(( bullet )=>{
        bullet.classList.remove("is-hidden");
    });

    button.classList.add("is-hidden");
}

let has_products = false;

$: {
    if(parsedPlans){
        has_products = false;
        parsedPlans.map((plan)=>{
            if(plan.type === "PRODUCT"){
                has_products = true;
            }
        })

        if(has_products === true){
            parsedPlans.reverse();
        }
    }
}



</script>
{#if $PlansStore.plans_views.length <= 0}
    <h2 class="font-size-20 has-text-centered has-text-dark">
        Cargando planes...
    </h2>
{/if}
{#each parsedPlans as plan}
    <card-plan class="column column-card-plan container-plan-{plan.__id__}">
        <section class="{plan.is_recommended} {has_products ? 'has-products pt-0' : ""} is-plan padding-40 has-radius">
            <header-tab-title>
                {#if has_products === false}
                    {#if plan.is_recommended === "Recomendado" || plan.is_recommended === "recommended"}
                        <h4 class="defaultItem header-title {plan.has_discount}  has-text-centered">
                            {metadata.lang.defaultItem}
                        </h4>
                    {/if}    
                {/if}
                {#if has_products}
                    <h4 class="{plan.has_discount} {plan.type === "PLAN" ? "header-title": "header-title-product"}
                    gap-alt-8 is-flex is-align-items-center is-justify-content-center has-text-centered">
                        {#if plan.type === "PRODUCT"}
                            <i class="icon-tripod-number-one font-size-20"></i>
                            {:else}
                                <i class="icon-tripod-bills font-size-20"></i>
                        {/if}
                        <span>{metadata.lang?.on_plan_type[plan?.type ?? "PLAN"] ?? ""}</span>
                    </h4>
                {/if}
            </header-tab-title>               
            <header class="is-flex">
                <div>
                    <h2 class="font-size-24 has-text-centered is-justify-content-center has-text-weight-bold has-text-black is-flex Title-Plan-{plan.is_recommended}">
                        <span class="name_plan-span">
                            {plan.name_plan}
                        </span>
                    </h2>
                    <div class="container-discount">
                        {#if (plan?.hasReferralDiscounts ?? false) === false}
                            {#if Number.isInteger(plan.percentOff)}
                                {#if plan.percentOff > 0}
                                    <p class="has-text-centered">
                                        <span class="percent-off-tag has-text-success fw400 font-size-14 {plan.is_recommended}">
                                            Ahorra {plan.percentOff}%
                                        </span>
                                    </p>
                                {/if}
                            {/if}
                            {:else}
                                <p class="has-text-centered">
                                    <span class="percent-off-tag has-text-success fw400 font-size-14 {plan.is_recommended}">
                                        Ahorra {plan.hasReferralDiscounts}%
                                    </span>
                                </p>
                        {/if}
                    </div>
                    <p class="has-text-centered font-size-36 has-text-weight-semibold price-element-container main-price {plan.is_recommended}">
                        <span class="price-element has-text-black">
                            <span class="font-size-36 fw500 fw700">
                                {plan.currency[0]}<CurrencyFormatter parseCents={true} number={plan.interval_price} /><span class="font-size-20 fw500">
                                    {plan.currency[1]}
                                    {#if plan.type === "PLAN"}
                                        <span>
                                            /{metadata.lang.eachMonth}
                                        </span>
                                    {/if}
                                </span>
                            </span>
                        </span>
                    </p>
                    {#if (plan?.hasReferralDiscounts ?? false) !== false}
                        <p class="has-text-centered font-size-36 has-text-weight-semibold price-element-container dontpay-price">
                            <span class="price-element has-text-black">
                                <span class="font-size-14 fw500" style="text-decoration: line-through;">
                                    {plan.currency[0]}<CurrencyFormatter classes="font-size-14" parseCents={true} number={plan.interval_current_price} />
                                    {plan.currency[1]}
                                    {#if plan.type === "PLAN"}
                                        <span>
                                            /{metadata.lang.eachMonth}
                                        </span>
                                    {/if}
                                </span>
                            </span>
                        </p>
                    {/if}
                    
                    {#if plan.yearly !== null && interval === "year"}
                        {#if plan[`interval_${interval}_price`] ?? "" !== ""}
                            <p class="has-text-centered font-size-14 has-text-black">
                                {#if interval === "year"}
                                    {plan.currency[0]}<CurrencyFormatter classes="font-size-14" parseCents={true} number={plan.interval_price*12} />
                                {/if}
                                {plan.currency[1]}/<span class="is-lowercase">{metadata.lang.year}</span>
                            </p>
                        {/if}
                    {/if}
                    <!-- pay button start -->
                    <section class="button-pay">
                        {#if plan.active === false }
                            <div class="buttons is-grouped is-centered button-container-select">
                                <button
                                    on:click="{SelectPlanInit}"
                                    data-plan-id="{plan.__id__}" 
                                    data-price-on-year-monthly="{plan.price_on_year_monthly}"
                                    data-position-plan="{plan.position_plan}"
                                    data-type="{plan.type}"
                                    data-membership-type="{parse_membership_name(plan.membership_type)}"
                                    data-interval="{interval}"
                                    type="button" class="button is-primary button-select-plan">
                                    <span class="is-capitalized">
                                        {lang.setPlan}
                                    </span>
                                </button>
                            </div>
                            {:else}
                                <!-- current plan -->
                                <div class="buttons is-grouped is-centered button-container-select">
                                    <button 
                                        data-plan-id="{plan.__id__}"
                                        data-type="{plan.type}"
                                        
                                        data-membership-type="{plan.membership_type}"
                                        data-interval="{interval}"
                                        type="button" 
                                        class="button is-primary button-select-plan is outlined-white fw400 has-text-white button-primary-3pod outlined-white"
                                        disabled="true"                                        
                                    >
                                        <span class="is-capitalized">
                                            {lang.currentPlan ?? lang.updatePlan ?? lang.setPlan}
                                        </span>
                                    </button>
                                </div>
                        {/if}
                    </section>                  
                </div>                    
            </header>     
            <hr class="my-alt-4" style="height: 1px;">           
            <main>
                <ul class="container-items pt-0">
                    {#each Object.values(JSON.parse(plan.items)) as item, key}
                        <li class="item-list {key > 3 ? "is-hidden hidden-bullets" : ""}">
                            <p class="content-item font-size-14 has-text-black is-flex is-align-items-center gap-alt-8">
                                <span>
                                    <i class="icon-tripod-checklist-alt has-text-success font-size-20"></i>
                                </span>
                                <span>
                                    {@html template_item(item, plan)}
                                </span>
                            </p>
                        </li>
                    {/each}                        
                </ul>
                {#if Object.values(JSON.parse(plan.items)).length > 4 }
                    <button class="button is-fullwidth is-ghost has-text-centered has-text-primary" on:click={show_more_details}>
                        {lang?.see_more_details ?? "Ver más detalles"}
                    </button>
                {/if}
            </main>
            <footer>
                <!-- deactivate membership email marketing -->
                <!--{#if plan.membership_type === "funnels"}
                    {#if (lang?.slider?.benefits||null) !== null}
                        <div class="columns is-multiline">
                            <div class="column email-marketing-slider-module {plan.__id__}">
                                <EmailMarketingSlider interval={interval} onUpdate={EmailMarketingSliderUpdate} CurrentAddon={(plan)} version={plan.is_recommended.toLowerCase()} id={"slider-"+random_string(3)} lang={lang.slider} />
                            </div>
                        </div>
                    {/if}
                {/if}-->         
            </footer>
        </section>
    </card-plan>
{/each}

<style>

:global(.section) .Title-Plan-recommended, :global(.section) .Title-Plan-recommended .name_plan-span{
    color: #fff;
}
header{
    justify-content: center;
    position: relative;
}
section.is-plan{
    position: relative;
    height: 100%;
    max-width: 340px;
    padding-bottom: 2rem;
    margin: auto;
    border: 1px solid var(--color-extralightGrey)
}
section.is-product{
    margin-top: 1.25rem;
}
@media only screen and (max-width:1023px){
    section.is-product{
        display: grid;
        justify-items: center;
    }
}
.email-marketing-slider-module{
    margin-bottom: 1.75rem;
}
@media only screen and (max-width: 1268px){
    .email-marketing-slider-module{
        margin-bottom: 2.75rem;
    }
}
@media only screen and (max-width: 425px){
    .email-marketing-slider-module{
        margin-bottom: 3.75rem;
    }
}

.header-title, .header-title-product{
    position: absolute;
    width: 100%;
    left: 0;
    background: var(--color-primary);
    border-radius: 20px 20px 0 0;
    padding: 12px 0;
    color: #fff;
}
.header-title-product{
    background: #fff;
    color: var(--color-primary);
    border-bottom: 1px solid var(--color-extralightGrey);
}
@media only screen and (max-width: 900px){
    .header-title, .header-title-product{
        background: var(--color-primary);
        border-radius: 8px 8px 0 0;
        padding: 12px 0;
    }
    .header-title-product{
        background: #fff;
        color: var(--color-primary);
    }
}

section:global(.recommended){
    position: relative;
    background: var(--color-grey-alt1);
    padding-top: 0;
    border: 0;
}
section:global(.recommended:not(.has-products)){
    transform: scale(1.06);
}


section:global(.recommended) header, section:global(.has-products) header{
    padding-top: calc(2.5em + 1.25em);
    color: #fff;
}
.main-price, .dontpay-price{
    position: relative;
    margin-bottom: 0;
}
.currency-symbol{
    position: relative;
}
.item-list{
    font-size: 0.85rem;
    padding: 0.25rem;
}
section:global(.recommended .item-list){
    color: #fff;
}
.item-list .icon{
    width: 9px;
    height: 9px;
    padding: 9px;
    font-size: 9px;
    border-radius: 40px;
    background: var(--color-primary);
    color: #fff;
}
section:global(.recommended .item-list .icon){
    background: var(--color-yellow);
    color: var(--color-dark-grey);
}
.text-on-current{
    color: #424B54;
}
section:global(.recommended .text-on-current){
    color: #fff;
}

.container-items{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 1.25rem 1rem;
}
.container-items-product{
    padding: 0.25rem 2rem;
}
.item-list-product {
    display: inline-flex;
    width: 320px;
}
footer{
    padding: 0 !important;
    padding-top: 2rem !important;    
}
.recommended .content-item :global(strong){
    color: #fff
}
.content-item :global(strong){
    color: var(--color-primary);
}
.item-list{
    padding: 0px
}
.column-card-plan{
    min-width: 340px;
}
.special-discount-from-referral{
    background: var(--color-purple) !important;
    color:#fff !important;
}
.main-price.recommended .price-element{
    color: var(--color-yellow);
    
}
.price-element, .price-element-container{
    display: flex;
    align-items: baseline;
}
.price-element-container{
    justify-content: center;
}
.price-element-container-product{
    margin-left: 4.25rem;
    color: var(--color-dark-grey);
}
.price-element-product{
    display: inline-flex;
}
.container-discount {
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    top: 10px;
}
</style>